import { EmptyState } from '../components/EmptyState.js';

export function PullsPage() {
  return (
    <EmptyState
      title="Pull requests"
      body="List of recent PRs with their Feluda review status. Lands in a follow-up plan once the storage shape for per-PR state settles."
    />
  );
}